import { useContext, useEffect, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import {
  SET_SELECTED_VISUAL_AID_DATA,
  SHOW_HIDE_VISUAL_AID_FORM,
  UPDATE_CHANGE_VISUAL_AID_DATA,
  VisualAidContext,
} from '../context/context'
import InputText from '../../../common/InputText'
import SelectInput from '../../../common/SelectInput'
import Button from '../../../common/Button'
import { getRequest, postRequest, putRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'
import FileField from '../../../common/FileField'
import useDebouncedValue from '../../../../utils/common_function'
import { XCircle } from '@styled-icons/boxicons-solid'

const VisualAidForm = ({ getVisualAidList }) => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(VisualAidContext)
  const [navState, navDispatch] = useContext(NavContext)

  const [optionCodes, setOptionCodes] = useState([])
  const [searchSalesCode, setSearchSalesCode] = useState('')
  const [visualAidTypeOptions, setVisualAidTypeOptions] = useState([])
  const debouncedToSearchSalesCode = useDebouncedValue(searchSalesCode, 1000)
  const [showOptionCodeLoader, setShowOptionCodeLoader] = useState(false)

  useEffect(() => {
    getOptionCodeOptions(searchSalesCode)
  }, [debouncedToSearchSalesCode])

  useEffect(() => {
    getVisualAidType()
  }, [])

  const closePopUp = () => {
    dispatch({
      type: SHOW_HIDE_VISUAL_AID_FORM,
      data: false,
    })
  }

  const getVisualAidType = async () => {
    let res = await getRequest(
      `/api/visual_aid/visual-aid-type/?vehicle=${vehicle}`
    )
    setVisualAidTypeOptions(res?.data)
  }

  const getOptionCodeOptions = async (search) => {
    setShowOptionCodeLoader(true)
    let res = await getRequest(
      `/api/option_codes/options/?vehicle=${vehicle}&search=${search}`
    )
    setOptionCodes(res?.data)
    setShowOptionCodeLoader(false)
  }

  const saveVisualAidData = async (e) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Saving Visual Aid Data',
        showLoader: true,
      },
      notification: {},
    })

    const formData = new FormData(e.target)
    formData.append('vehicle', vehicle)

    if (state?.selectedObject?.id) {
      let res = await putRequest(
        `/api/visual_aid/${state?.selectedObject?.id}/?vehicle=${vehicle}`,
        formData
      )
      if (res?.status) {
        dispatch({
          type: UPDATE_CHANGE_VISUAL_AID_DATA,
          data: state?.selectedObject,
        })
        closePopUp()

        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `Visual Aid Successfully Saved`,
          },
        })
        getVisualAidList()
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    } else {
      let res = await postRequest(`/api/visual_aid/`, formData)
      if (res?.status) {
        closePopUp()
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `Visual Aid Successfully Saved`,
          },
        })
        getVisualAidList()
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }

  const clearFile = async () => {
    dispatch({
      type: SET_SELECTED_VISUAL_AID_DATA,
      data: {
        ...state?.selectedObject,
        visual_aid_file: null,
      },
      showFormPopup: true,
    })
  }

  return (
    <Modal
      onClose={() => {
        closePopUp()
      }}
      show={state?.showVisualAidFormPopup}
      size={`w-3/4`}
    >
      <ModalHeader className={'text-white'}>Visual Aid's</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            saveVisualAidData(e)
          }}
        >
          <div className="flex flex-row flex-wrap">
            <div className="w-1/2">
              <InputText
                name="name"
                value={state?.selectedObject?.name}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_VISUAL_AID_DATA,
                    data: {
                      ...state?.selectedObject,
                      name: value,
                    },
                    showFormPopup: true,
                  })
                }}
                label={'Visual Aid Name'}
                type="text"
                className="w-1/2"
                isRequired={true}
              />
            </div>
            <div className="w-1/2">
              <InputText
                name="code"
                value={state?.selectedObject?.code}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_VISUAL_AID_DATA,
                    data: {
                      ...state?.selectedObject,
                      code: value,
                    },
                    showFormPopup: true,
                  })
                }}
                label={'Visual Aid Code'}
                type="text"
                isRequired={true}
                className="w-1/2"
              />
            </div>
            <div className="w-1/2">
              <SelectInput
                name={`aid_type`}
                isMulti={false}
                label={`Visual Aid Type`}
                isRequired={true}
                value={
                  state?.selectedObject?.aid_type
                    ? {
                        value: state?.selectedObject?.aid_type,
                        label: state?.selectedObject?.aid_type,
                      }
                    : null
                }
                options={visualAidTypeOptions}
                onChange={(option) => {
                  dispatch({
                    type: SET_SELECTED_VISUAL_AID_DATA,
                    data: {
                      ...state?.selectedObject,
                      aid_type: option.value,
                    },
                    showFormPopup: true,
                  })
                }}
              />
            </div>
            <div className="w-1/2">
              <SelectInput
                name={`sales_codes`}
                isMulti={true}
                label={`Sales Code`}
                isRequired={true}
                onInputChange={(search) => {
                  setSearchSalesCode(search)
                }}
                value={state?.selectedObject?.sales_codes_data}
                options={optionCodes}
                onChange={(values) => {
                  dispatch({
                    type: SET_SELECTED_VISUAL_AID_DATA,
                    data: {
                      ...state?.selectedObject,
                      sales_codes_data: values,
                    },
                    showFormPopup: true,
                  })
                }}
                showLoader={showOptionCodeLoader}
              />
            </div>
            <div className="w-1/2 text-white">
              {state?.selectedObject?.visual_aid_file ? (
                <div className="p-2 cursor-pointer">
                  <div htmlFor="visual_aid_file">Visual Aid File</div>
                  <XCircle
                    className={'w-4 text-red-500 mr-3'}
                    onClick={(e) => clearFile()}
                  />
                  {state?.selectedObject?.visual_aid_file_name}
                </div>
              ) : (
                <FileField
                  isRequired={true}
                  name={`visual_aid_file`}
                  label={`Visual Aid File`}
                  onChange={() => {}}
                />
              )}
            </div>
            <div className="w-1/2">
              <InputText
                name="visual_aid_file_name"
                value={`${state?.selectedObject?.visual_aid_file_name}`}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_VISUAL_AID_DATA,
                    data: {
                      ...state?.selectedObject,
                      visual_aid_file_name: value,
                    },
                    showFormPopup: true,
                  })
                }}
                label={'Visual Aid File Name'}
                type="text"
                isRequired={true}
                className="w-1/2"
              />
            </div>
          </div>
          <div className="flex justify-end p-2">
            <Button
              text={`Save Visual Aid `}
              className={`cursor-pointer btn my-4 w-auto justify-end`}
              onClick={() => {}}
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default VisualAidForm
